import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import { App } from './App.tsx';
// Die Schrift liegt im Paket, nicht bei Google — sie muss ohne Verbindung da sein.
import '@fontsource-variable/outfit';
import './styles.css';

/**
 * Updates werden angeboten, nicht erzwungen (PV-B21). Ob sie eingespielt
 * werden duerfen, entscheidet App.tsx — waehrend gearbeitet wird oder solange
 * Aenderungen offen sind, wird nicht aktualisiert (PV-B22).
 */
const aktualisiere = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('pv:neue-version'));
  },
});
window.addEventListener('pv:version-uebernehmen', () => void aktualisiere(true));

createRoot(document.getElementById('wurzel')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
